var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('e-tooltip',{attrs:{"content":"Open Preview in New Window"}},[_c('button',{staticClass:"e-btn e-btn-onlyicon e-btn-borderless",on:{"click":function($event){return _vm.openInNewWindow()}}},[_c('e-icon',{attrs:{"icon":"e-external-link"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }